import { IProjectBudgetCost, IProjectBudgetCostChart } from '../views/project/types/costs';
import { IPagination } from '../types/pagination';
import { HttpClient } from './service';
import Urls from './urls';

export const BudgetCostsApi = {
  getProjectCosts(projectId: string | number, queryParams: Record<string, string>): Promise<IProjectBudgetCost[]> {
    return HttpClient.get<IProjectBudgetCost[], Record<string, string>>(`${Urls.Projects.projects}${projectId}/budget-costs/`, queryParams)
  },

  getOutstandingPayments(projectId: string | number, queryParams: Record<string, string>): Promise<IProjectBudgetCost[]> {
    return HttpClient.get<IProjectBudgetCost[], Record<string, string>>(`${Urls.Projects.projects}${projectId}/budget-costs/outstanding-payments/`, queryParams)
  },

  getPaginatedOutstandingPayments(projectId: string | number, queryParams: Record<string, string>): Promise<IPagination<IProjectBudgetCost[]>> {
    return HttpClient.get<IPagination<IProjectBudgetCost[]>, Record<string, string>>(`${Urls.Projects.projects}${projectId}/budget-costs/outstanding-payments/`, queryParams)
  },

  getProjectCostsBudgetChart(projectId: string | number, queryParams: Record<string, string>): Promise<IProjectBudgetCostChart> {
    return HttpClient.get<IProjectBudgetCostChart, Record<string, string>>(`${Urls.Projects.projects}${projectId}/budget-costs/chart/`, queryParams)
  },

  getProjectCost(projectId: number | string, cost: IProjectBudgetCost): Promise<IProjectBudgetCost> {
    return HttpClient.get<IProjectBudgetCost, IProjectBudgetCost>(`${Urls.Projects.projects}${projectId}/budget-costs/${cost.id}/`)
  },

  updateProjectCost(projectId: number | string, cost: IProjectBudgetCost): Promise<IProjectBudgetCost> {
    return HttpClient.put<IProjectBudgetCost, IProjectBudgetCost>(`${Urls.Projects.projects}${projectId}/budget-costs/`, cost.id, cost)
  },

  deleteProjectCost(projectId: number | string, cost: IProjectBudgetCost): Promise<string | number> {
    return HttpClient.delete<string | number, string | number>(`${Urls.Projects.projects}${projectId}/budget-costs/`, cost.id)
  },

  createProjectCost(projectId: number | string, cost: IProjectBudgetCost): Promise<IProjectBudgetCost> {
    return HttpClient.post<IProjectBudgetCost, IProjectBudgetCost>(`${Urls.Projects.projects}${projectId}/budget-costs/`, cost)
  }
}
